import { PodcastTemplateConfig } from 'redux/middleware/api/podcast-service';
import { DEFAULT_BG_COLOR } from './constants';

export function getBackgroundColor(config: PodcastTemplateConfig) {
  return config?.mainMediaContainer?.style?.backgroundColor ?? DEFAULT_BG_COLOR;
}
